module.exports = __webpack_public_path__ + "static/Sunanda.3366dfaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Sunanda.jpg
// module id = 1324
// module chunks = 137408898365125